import React from 'react';

class SyncButton extends React.Component {
  render() {
    const className = this.props.syncing ? 'fa-spinner fa-spin' : 'fa-sync-alt'

    return (
      <button style={{width: "146px", height: "36px"}} disabled={this.props.syncing} className="btn mfc-btn-blue" type="button" onClick={this.props.onClick}>
        <i className={`fas ${className} ${this.props.className}`}></i>
        {!this.props.syncing && <span style={{paddingLeft: "7px"}}>{this.props.label}</span>}
      </button>
    );
  }
}

export default SyncButton;
